import { Link } from "react-router";
import { adminPaths } from "../AdminApp";
import { getEnv } from "../lib/utils";
import AdminLayout from "../components/AdminLayout";

export default function Dashboard() {
  const adminFeatures = [
    {
      title: "API Keys",
      description: "Manage API key access",
      href: adminPaths.apiKeys(),
      icon: "🔑",
    },
    {
      title: "Intercom Sync",
      description: "Manually recalculate user attributes in Intercom",
      href: adminPaths.intercomSync(),
      icon: "🔄",
    },
    {
      title: "Add Credits",
      description:
        "Search for users and manually add credits to their billing accounts",
      href: adminPaths.addCredits(),
      icon: "💳",
    },
    {
      title: "Sync Billing",
      description:
        "Search for users and manually sync their billing accounts with Stripe",
      href: adminPaths.syncBilling(),
      icon: "🔄",
    },
    {
      title: "Assign Superuser Roles",
      description: "Search for users and assign superuser roles",
      href: adminPaths.addRole(),
      icon: "👤",
    },
    {
      title: "Invite User",
      description: "Send team invites to users for existing or new teams",
      href: adminPaths.inviteUser(),
      icon: "📧",
    },
    {
      title: "Copy Overlay Template",
      description:
        "Copy an overlay template from one team to another with all media assets",
      href: adminPaths.copyOverlayTemplate(),
      icon: "📋",
    },
    {
      title: "Join or Leave Teams",
      description: "Search for a user by email and join or leave their teams",
      href: adminPaths.teamMemberships(),
      icon: "👥",
    },
    {
      title: "Manage Invites",
      description: "View, resend, and copy invite links for existing invites",
      href: adminPaths.manageInvites(),
      icon: "📨",
    },
    {
      title: "Manage Team Members",
      description:
        "Look up a team by ID, view its members, and add new members",
      href: adminPaths.manageTeamMembers(),
      icon: "🏢",
    },
    {
      title: "Block Rules",
      description:
        "Block use cases like initial credits by country or IP address",
      href: adminPaths.blockRules(),
      icon: "🚫",
    },
    {
      title: "Fonts",
      description: "View all uploaded font previews stored in the database",
      href: adminPaths.fonts(),
      icon: "🔤",
    },
    {
      title: "Background Music Peaks",
      description:
        "Backfill pre-decoded waveform peaks for background music tracks missing them",
      href: adminPaths.backgroundMusicPeaks(),
      icon: "🎵",
    },
  ];

  return (
    <AdminLayout
      title="Admin Dashboard"
      description="Manage Amplifiles system administration tasks"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        {adminFeatures.map((feature) => (
          <div
            key={feature.title}
            className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition-shadow"
          >
            <div className="flex items-center mb-4">
              <span className="text-2xl mr-3">{feature.icon}</span>
              <h3 className="text-lg font-semibold text-gray-900">
                {feature.title}
              </h3>
            </div>
            <p className="text-gray-600 mb-4">{feature.description}</p>
            <Link
              to={feature.href}
              className="block w-full py-2 px-4 bg-blue-600 text-white text-center rounded-lg hover:bg-blue-700 transition-colors"
            >
              Open
            </Link>
          </div>
        ))}
      </div>

      <div className="mt-8 text-center">
        <a
          href={getEnv("VITE_STUDIO_URL")}
          className="inline-flex items-center px-4 py-2 text-blue-600 hover:text-blue-700 transition-colors"
        >
          ← Back to Studio
        </a>
      </div>
    </AdminLayout>
  );
}
